module.exports = __webpack_public_path__ + "img/40_69_002_080.b0e4de15.jpg";